import { ReturnBlock } from "../../../ReturnBlock";

/**
 * The boolean NOT
 */
export class NOTBlock extends ReturnBlock {
    bool;

    /**
     * Constructor
     * @param inputs the inputs (only cares about inputs[0]).
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id)
        this.bool = inputs[0];
    }

    /**
     * Performs boolean NOT operation on input.
     * @param varEnv the variable envornment
     */
    evalBlock(varEnv: Map<string, any>): boolean {
        let input = Boolean(this.bool.evalBlock(varEnv));
        return !input;
    }
}